<template>
  <div class="guide-container">
    <portal to="guide-button-dest">
      <div v-if="filteredSteps.length > 0" class="button-help" ref="guide_button">
        <span class="icon-question-circle" id="btn-show-guide" :class="{ 'is-active': getGuideVisibility }" @click="showGuide"></span>
      </div>
    </portal>
    <portal to="overray-dest">
      <div class="guide-overray" ref="guideoverray" @click="hideGuide"></div>
    </portal>
    <v-tour name="conicTour" :steps="steps_checked" :callbacks="guideCallbacks">
      <template slot-scope="tour">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :step="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
        >
          <div slot="actions" class="v-step__actions">
            <button @click="tour.stop" class="v-step__button">{{ $t("guide_close") }}</button>
            <button v-if="!tour.isFirst" @click="tour.previousStep" class="v-step__button">{{ $t("guide_prev") }}</button>
            <button v-if="!tour.isLast" @click="tour.nextStep" class="v-step__button">{{ $t("guide_next") }}</button>
          </div>
        </v-step>
      </template>
    </v-tour>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'conic-tour',
  props: {
    steps: {
      type: Array,
      default: function() {
        return []
      }
    },
  },
  components: {},
  data () {
    return {
      scrollTriggerPoint: 30,
      steps_checked: [],
      guideCallbacks: {
        onStop: this.completeGuidance,
      }
    }
  },

  beforeMount() {},

  mounted() {
    // console.log(this.steps_checked)
    // window.addEventListener('scroll', _.throttle(this.handleScroll, 100), { passive: false })
  },

  computed: {
    ...mapGetters([
      'getGuideVisibility',
    ]),
    filteredSteps: function () {
      return this.steps.filter(function (step) {
        return document.querySelector(step.target)
      }, this)
    }
  },

  methods: {
    ...mapActions([
      'setGuideVisibility',
    ]),
    handleScroll: function(e){ // eslint-disable-line no-unused-vars
      const posTop = window.pageYOffset
      if(this.$refs.guide_button){
        if(posTop > this.scrollTriggerPoint){
          // console.log('in', e)
          this.$refs.guide_button.classList.add('is-fixed')
        } else {
          // console.log('out', e)
          this.$refs.guide_button.classList.remove('is-fixed')
        }
      }
    },
    checkSteps: function(){
      this.steps_checked = []
      this.steps.forEach(step => {
        const trg = document.querySelector(step.target)
        if(trg){
          this.steps_checked.push({...step, content: this.$i18n.t(step.content)})
        }
      })
    },
    showGuide: function(){
      // this.translateContent()
      this.checkSteps()
      this.$refs.guideoverray.classList.add('is-active')
      this.setGuideVisibility({ visibility: true })
      this.$nextTick(function(){
        this.$tours['conicTour'].start()
      })
    },
    hideGuide: function(){
      this.$tours['conicTour'].stop()
      this.completeGuidance()
    },
    completeGuidance: function(){
      this.$refs.guideoverray.classList.remove('is-active')
      this.setGuideVisibility({ visibility: false })
    },
    translateContent: function(){
      for (let index = 0; index < this.steps.length; index++) {
        this.steps[index].content = this.$i18n.t(this.steps[index].content)
      }
    }
  }
}
</script>
<style lang="sass"></style>
